export const packageItems = [
  {
    id: 1,
    usdAmount: 3
  },
  {
    id: 2,
    usdAmount: 5
  },
  {
    id: 3,
    usdAmount: 13
  },
  {
    id: 4,
    usdAmount: 23
  },
  {
    id: 5,
    usdAmount: 11
  }
]
